import { z } from 'zod';

import type { Thread } from '@/submodules/himam-common-components/src/helpers/interfaces/thread.interface';

export const RedisChannels = {
  NOTIFICATIONS: 'notifications',
  ORDERS: 'orders',
  WALLET: 'wallet',
  COPYLEAK: 'copyLeak',
  SUBSCRIPTION_INVOICE: 'subscription-invoice',
  CONVERSATIONS: 'conversations',
} as const;

export type RedisChannels = (typeof RedisChannels)[keyof typeof RedisChannels];
export const BaseSsePayloadSchema = z.object({
  channel: z.nativeEnum(RedisChannels),
});
export type BaseSsePayload = z.infer<typeof BaseSsePayloadSchema>;

export const NotificationSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.NOTIFICATIONS),
});
export type NotificationSsePayload = z.infer<
  typeof NotificationSsePayloadSchema
>;

export const OrdersSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.ORDERS),
});
export type OrdersSsePayload = z.infer<typeof OrdersSsePayloadSchema>;

export const WalletSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.WALLET),
});
export type WalletSsePayload = z.infer<typeof WalletSsePayloadSchema>;

export const CopyLeakSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.COPYLEAK),
});
export type CopyLeakSsePayload = z.infer<typeof CopyLeakSsePayloadSchema>;

export const SubscriptionInvoiceSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.SUBSCRIPTION_INVOICE),
});
export type SubscriptionInvoiceSsePayload = z.infer<
  typeof SubscriptionInvoiceSsePayloadSchema
>;

export const ConversationsSsePayloadSchema = BaseSsePayloadSchema.extend({
  channel: z.literal(RedisChannels.CONVERSATIONS),
  data: z.object({
    conversation: z.custom<Thread>(),
    isNewConversation: z.coerce.boolean(),
  }),
});
export type ConversationsSsePayload = z.infer<
  typeof ConversationsSsePayloadSchema
>;

export const SsePayloadSchema = z.union([
  NotificationSsePayloadSchema,
  OrdersSsePayloadSchema,
  WalletSsePayloadSchema,
  CopyLeakSsePayloadSchema,
  SubscriptionInvoiceSsePayloadSchema,
  ConversationsSsePayloadSchema,
  BaseSsePayloadSchema,
]);
